import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css'; // On déporte le CSS pour garder le JSX propre

export const NotFound = () => {
  return (
    <div className="main-container-404">
      {/* Motif nid d'abeille en arrière-plan */}
      <div className="honeycomb-pattern"></div>
      
      <div className="container-404">
        <div className="icon-buzz">🐝</div>
        
        <div className="error-code">404</div>
        
        <h1>Cette page s'est envolée avec les abeilles !</h1>
        
        <p>
            La page que vous recherchez n'existe pas ou a été déplacée. 
            Nos abeilles n'ont pas pu la retrouver dans la ruche.
        </p>

        <div className="suggestions">
            <h2>Pages populaires :</h2>
            <ul>
                <li>🏠 <Link to="/">Accueil</Link></li>
                <li>📚 <Link to="/getting-started">Guide pour débuter</Link></li>
                <li>🛠️ <Link to="/equipment">Équipement nécessaire</Link></li>
                <li>📖 <Link to="/blog">Blog & Articles</Link></li>
                <li>📜 <Link to="/legal">Réglementation</Link></li>
            </ul>
        </div>

        <div className="button-group-404">
            <Link to="/" className="button-404 button-primary-404">Retour à l'accueil</Link>
            <Link to="/blog" className="button-404 button-secondary-404">Lire le blog</Link>
        </div>

        <div className="footer-404">
            <p>UrbanHive - L'Apiculture sur Votre Balcon</p>
        </div>
      </div>
    </div>
  );
};